import React from 'react';
import PropTypes from 'prop-types';

import './FlexibleRankCalculator.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class FlexibleRankCalculator extends React.PureComponent {
  static describeRank = rank => rank.toString();

  generateMarks = () => {
    const {min, max} = this.props;

    const marksMax = 7;
    const markStep = Math.ceil((max - min) / marksMax);

    let marks = {};

    for (let i = min; i <= max; i += markStep) {
      marks[i] = `${i}`;
    }

    return marks;
  };

  render() {
    const {intl, collapsed, min, max, value, onChange} = this.props;
    const marks = this.generateMarks();

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={min}
              max={max}
              value={value[0]}
              onChange={(newValue) => onChange([newValue, value[1]])}
            />
          </div>

          <div className="range-inputs__divider" />

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={min}
              max={max}
              value={value[1]}
              onChange={(newValue) => onChange([value[0], newValue])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-flexible"
              step={1}
              min={min}
              max={max}
              marks={marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/flexibleRankPicker/FlexibleRankPicker.js